import React from 'react';
import { FormGrid, SimpleDialog } from '../../../toolympus/components/primitives';
import { FormControlsForFields } from '../../../toolympus/components/schemed';
import { Button } from '@mui/material';
import { useUserSettingsBlockEditor } from '../../../toolympus/components/Settings/useUserSettingsBlockEditor';
import { FieldType, Schema } from '../../../toolympus/hooks/useSchema';


export const PaymentSettingsSchema: Schema = {
  merchant_login: { label: "Merchant login" },
  password_1: { label: "Password 1" },
  password_2: { label: "Password 2" },
  result_url2: { label: "Result URL 2" },
  is_test: { label: "Test mode", type: FieldType.bool },
}


export const PaymentSettingsPopupButton = () => {
  const data = useUserSettingsBlockEditor("payments", { apiPath: "/api/admin-settings" });

  return (
    <>
        <Button size="small" onClick={() => data.start()}>
          payment settings
        </Button>

        <SimpleDialog
          isOpen={data.isEditing}
          close={() => data.cancel()}
          noFullscreen
          dialogTitle="Payment settings"
          save={() => data.save()}>
          
          <FormGrid columns="1fr">
            <FormControlsForFields
              schema={PaymentSettingsSchema}
              data={data.item}
              onChange={(o,c) => data.update(c)}
              fields={[
                ["merchant_login"],
                ["password_1"],
                ["password_2"],
                ["result_url2"],
                ["is_test"],
              ]}
              />
          </FormGrid>
        </SimpleDialog>
    </>
  )
}